import { EntitlementType } from "../types/EntitlementTypes";
import { AnalyticsOnlyMetrics } from "./Constants";

export const getDefaultRoute = (entitlements: EntitlementType[]): string => {
  if (entitlements.includes("catalog")) {
    return "/catalog";
  } else if (entitlements.includes("analytics")) {
    return "/performance";
  } else {
    return "/permission-denied";
  }
};

export const filterMetricsByEntitlement = (
  metricsList: Array<{ label: string; value: string }>,
  hasAnalyticsEntitlement: boolean,
): Array<{ label: string; value: string }> => {
  if (hasAnalyticsEntitlement) {
    return metricsList;
  }

  return metricsList.filter(
    (metric) => !AnalyticsOnlyMetrics.includes(metric.value),
  );
};
